import {pageInfo, initPage, saveData,initUpdate, editData,deleteData,exportData,orderBasicDetailsInfo,initOrderApprovedData,fileDownload,approveAgree, batchApproveAgree, refuseApproved} from './../api';
import {selectOrderStatus,selectOrderType,selectOrderRejectReason} from "../../../../api";
const salesApprove = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    exportObj: null,
    orderBasicInfoObj :null,
    orderListObj:null,
    fileObj: null,
    agreeObj: null,
    batchAgreeObj: null,
    refuseObj: null,
    orderStatusObj: null,
    orderTypeObj: null,
    orderRejectReasonObj:null,
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
      state.pageResp.map(item=>{
        item.showBtnIcon = item.schOrderWarnPOS.length > 0 ? true :false
      })
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    SAVE_DATA(state,data){
      state.addResp = data;
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    DELETE_DATA(state,data){
      state.deleteResp = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },

    ORDERBASIC_DETAILS_INFO(state, resp) {
      state.orderBasicInfoObj = resp.obj || {};
    },
    ORDER_LIST(state, data){
      state.orderListObj = data;
    },
    FILE_DATA(state, data) {
      state.fileObj = data;
    },
    AGREE_DATA(state, data) {
      state.agreeObj = data;
    },
    BATCH_AGREE_DATA(state, data) {
      state.batchAgreeObj = data;
    },
    REFUSE_DATA(state, data) {
      state.refuseObj = data;
    },
    ORDER_STATUS(state,data){
      state.orderStatusObj = data.obj || {};
    },
    ORDER_TYPE(state,data){
    state.orderTypeObj = data.obj || {};
    },
    ORDER_REJECT_REASON(state,data){
      state.orderRejectReasonObj = data.obj || {};
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //新增保存事件
    async saveData({commit}, obj){
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },

    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },

    //基本信息
    async orderBasicDetailsInfo({ commit }, obj) {
      let resp = await orderBasicDetailsInfo(obj);
      commit('ORDERBASIC_DETAILS_INFO', resp);
    },
    //订单数据初始化
    async initOrderApprovedData({ commit }, obj) {
      let resp = await initOrderApprovedData(obj);
      commit('ORDER_LIST', resp);
    },
    //附件下载
    async fileDownload({ commit }, obj) {
      let resp = await fileDownload(obj);
      commit('FILE_DATA', resp);
    },
    //同意
    async approveAgree({ commit }, obj) {
      let resp = await approveAgree(obj);
      commit('AGREE_DATA', resp);
    },
    //批量同意
    async batchApproveAgree({ commit }, obj) {
      let resp = await batchApproveAgree(obj);
      commit('BATCH_AGREE_DATA', resp);
    },
    //拒绝
    async refuseApproved({ commit }, obj) {
      let resp = await refuseApproved(obj);
      commit('REFUSE_DATA', resp);
    },
    async selectOrderStatus({commit}, obj){
      let resp = await selectOrderStatus(obj);
      commit('ORDER_STATUS', resp);
    },
    async selectOrderType({commit}, obj){
      let resp = await selectOrderType(obj);
      commit('ORDER_TYPE', resp);
    },
    async selectOrderRejectReason({commit}, obj){
      let resp = await selectOrderRejectReason(obj);
      commit('ORDER_REJECT_REASON', resp);
    },
  }
}
export default salesApprove



// WEBPACK FOOTER //
// ./src/page/order/salesApprove/store/salesApprove.store.js